// User service for user-related API calls
import { apiClient } from './apiClient';
import { API_CONFIG } from '../utils/constants';
import axios from "axios";



type EndpointField = keyof typeof API_CONFIG.ENDPOINTS;

export const commonService = {
    updatePicture: async (data: any): Promise<any> => {
        return await apiClient.post<any>(API_CONFIG.ENDPOINTS.PROFILE_PICTURE_UPDATE, data);
    },
    debitCredit: async (data: any): Promise<any> => {
        try {
            return await apiClient.post<any>(API_CONFIG.ENDPOINTS.DEBIT_CREDIT, data);
        } catch (error) {
            throw error;
        }
    },
    getCreditDetails: async (): Promise<any> => {
        try {
            return await apiClient.get<any>(API_CONFIG.ENDPOINTS.GET_CREDIT);
        } catch (error) {
            throw error;
        }
    },
    submitCreditRequest: async (data: any): Promise<any> => {
        try {
            return await apiClient.post<any>(API_CONFIG.ENDPOINTS.SUBMIT_CREDIT_REQUEST, data);
        } catch (error) {
            throw error;
        }
    },
    referAndEarn: async (data: any): Promise<any> => {
        return await apiClient.post<any>(API_CONFIG.ENDPOINTS.REFER_AND_EARN, data);
    },
    singleEmailVerify: async (data: any): Promise<any> => {
        return await apiClient.post<any>(API_CONFIG.ENDPOINTS.SINGLE_EMAIL_VERIFY, data);
    },
    profileUpdate: async (data: any): Promise<any> => {
        return await apiClient.post<any>(API_CONFIG.ENDPOINTS.UPDATE_USER, data);
    },
    update_list: async (data: any): Promise<any> => {
        return await apiClient.post<any>(API_CONFIG.ENDPOINTS.UPDATE_LIST, data);
    },
    newRequest: async (data: any): Promise<any> => {
        return await apiClient.post<any>(API_CONFIG.ENDPOINTS.NEW_DATA_REQUEST, data);
    },
    request: async (data: any): Promise<any> => {
        return await apiClient.post<any>(API_CONFIG.ENDPOINTS.REQUEST, data);
    },
    getSingleEmailResult: async (data: any): Promise<any> => {
        return await apiClient.get<any>(API_CONFIG.ENDPOINTS.EMAIL_VERIFY_RESULT + data);
    },
    removeProfilePicture: async (): Promise<any> => {
        return await apiClient.get<any>(API_CONFIG.ENDPOINTS.PROFILE_PICTURE_REMOVE);
    },
    getEmailVerifyList: async (data: any): Promise<any> => {
        return await apiClient.get<any>(API_CONFIG.ENDPOINTS.EMAIL_VERIFY_LIST, data);
    },
    loadProjectList: async (data: any): Promise<any> => {
        return await apiClient.get<any>(API_CONFIG.ENDPOINTS.PROJECT_LIST, data);
    },
    updateProjectRequest: async (data: any): Promise<any> => {
        return await apiClient.get<any>(API_CONFIG.ENDPOINTS.UPDATE_PROJECT_REQUEST + data);
    },
    bulkEmailVerify: async (data: any): Promise<any> => {
        try {
            const token = localStorage.getItem("accessToken");

            return await axios.post(
                API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.BULK_EMAIL_VERIFY,
                data,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: token ? `Bearer ${token}` : ""
                    }
                }
            );
        } catch (error) {
            throw error;
        }
    },
    feedback: async (data: any): Promise<any> => {
        try {
            const token = localStorage.getItem("accessToken");

            return await axios.post(
                API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.FEEDBACK,
                data,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: token ? `Bearer ${token}` : ""
                    }
                }
            );
        } catch (error) {
            throw error;
        }
    },
    dataEnrichment: async (data: any): Promise<any> => {
        try {
            const token = localStorage.getItem("accessToken");

            return await axios.post(
                API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.DATA_ENRICHMENT_REQUEST,
                data,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: token ? `Bearer ${token}` : ""
                    }
                }
            );
        } catch (error) {
            throw error;
        }
    },
    downloadBulkEmailResult: async (request_id: any): Promise<any> => {
        try {
            const token = localStorage.getItem("accessToken");

            return await axios.get(
                API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.EMAIL_VERIFY_BULK_RESULT + request_id,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: token ? `Bearer ${token}` : ""
                    }
                }
            );
        } catch (error) {
            throw error;
        }
    },
    downloadProject: async (data: any, format: string): Promise<any> => {
        try {
            const token = localStorage.getItem("accessToken");
            return await axios.get(
                API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.DOWNLOAD_PROJECT + data + `?format=${format}`,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: token ? `Bearer ${token}` : ""
                    }
                }
            );
        } catch (error) {
            throw error;
        }
    },

};

export default commonService;